<template>
<v-app>
  <v-row>
    <v-col cols="24" lg="20" offset-lg="2">
    <contact-form
      :name="name"
      :authentication-token="authenticationToken"
      :required-fields="requiredFields">
        <contact-logged-in></contact-logged-in>
        <zaehlerstand-fields :exclude="exclude"></zaehlerstand-fields>
    </contact-form>
    </v-col>
  </v-row>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import ZaehlerstandFields from "./ZaehlerstandFields";
import ContactLoggedIn from "../immoapp/contact/ContactLoggedIn";

export default {
  name: "ZaehlerstandFormApp",

  components: {
    ContactForm,
    ZaehlerstandFields,
    ContactLoggedIn
  },

  data() {
    return {
      name: "zaehlerstand"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.root.exclude;
      }

      return ignoreFields.concat(el);
    }
  }
};
</script>
